import { type ReactNode, useEffect } from 'react';
import { useMedia } from 'react-use';
import { X as CloseIcon } from '@hungryroot/icons';
import { log } from '@hungryroot/o11y';
import {
  ModalContent,
  ModalOverlay,
  Text,
  Heading,
  Button,
} from '@hungryroot/ramen';
import { segmentAnalytics as analytics } from '@hungryroot/segment';
import { BreakpointQueryLarge } from '@hungryroot/tokens';

import styles from './Modal.module.css';

export type Props = {
  backgroundImage: ReactNode;
  onClose: () => void;
};

export function ModalExitIntentModal({ onClose, backgroundImage }: Props) {
  const isDesktop = useMedia(BreakpointQueryLarge, false);
  const closeButton = (
    <button onClick={onClose} aria-label="Close Modal" className={styles.close}>
      <CloseIcon />
    </button>
  );

  const backgroundImageElement = (
    <div className={styles['image-container']}>{backgroundImage}</div>
  );

  useEffect(() => {
    analytics.track('Exit Modal No Inputs');
    log('modal-exit-intent', {
      key: 'exitIntentModal.shown',
      scope: 'cta',
      event: 'shown',
    });
  }, []);

  return (
    <ModalOverlay
      className={styles.container}
      onDismiss={onClose}
      isOpen={true}
    >
      {isDesktop === false && (
        <>
          {closeButton}
          {backgroundImageElement}
        </>
      )}

      <ModalContent
        ariaLabel="Before you go 30% off + get your choice of free gift."
        className={styles.content}
      >
        {isDesktop === true && (
          <>
            {closeButton}
            {backgroundImageElement}
          </>
        )}
        <div className={styles['text-content']}>
          <Heading className={styles['before-you-go']} variant="H6">
            Before you go...
          </Heading>

          <Heading variant="H3" className={styles.discount}>
            30% off
          </Heading>
          <Text className={styles['free-gift-copy']}>
            + get your choice of free gift.
          </Text>
          <Button
            onClick={() => {
              analytics.track('Exit Modal No Inputs CTA');
              log('modal-exit-intent', {
                key: 'exitIntentModal.cta.clicked',
                scope: 'cta',
                event: 'clicked',
              });
            }}
            buttonType="link"
            to="/quiz/hello/"
            size="large"
            style="muted"
            prominence="primary"
            width="full-width"
            textPrimary="Take The Quiz"
          />
        </div>
      </ModalContent>
    </ModalOverlay>
  );
}
